module.exports = __webpack_public_path__ + "static/media/eazydiner-logo.38c87c8e.png";